export default __webpack_public_path__ + "static/media/newdp.3f097719.jpg";